import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { MailX, Save } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/api";
import { useLang } from "@/i18n";
import { Switch } from "@/components/ui/switch";

const ITEMS = [
  { key: "newsletter", it: ["Newsletter e sequenza di benvenuto", "Consigli tecnici e novità di Guardia"], en: ["Newsletter & welcome series", "Technique tips and Guardia news"] },
  { key: "weekly", it: ["Articolo del giovedì", "L'avviso del nuovo articolo di curiosità ogni settimana"], en: ["Thursday article", "The weekly new curiosity article alert"] },
  { key: "reminders", it: ["Promemoria allenamento", "L'email delle 8:00 nei giorni del tuo calendario Blueprint"], en: ["Training reminders", "The 8:00 email on your Blueprint calendar days"] },
];

export default function EmailPreferences() {
  const { lang } = useLang();
  const [params] = useSearchParams();
  const token = params.get("t") || "";
  const [prefs, setPrefs] = useState(null);
  const [error, setError] = useState(false);
  const it = lang === "it";

  useEffect(() => {
    api.get(`/email-preferences/${encodeURIComponent(token)}`).then((r) => setPrefs(r.data)).catch(() => setError(true));
  }, [token]);

  const save = async (vals) => {
    try {
      const r = await api.put(`/email-preferences/${encodeURIComponent(token)}`, vals);
      setPrefs(r.data);
      toast.success(it ? "Preferenze salvate" : "Preferences saved");
    } catch (e) {
      toast.error(it ? "Errore, riprova" : "Error, try again");
    }
  };

  return (
    <div className="min-h-[70vh] max-w-xl mx-auto px-4 py-16">
      <h1 className="font-heading text-4xl sm:text-5xl font-black uppercase text-white">{it ? "Preferenze email" : "Email preferences"}</h1>
      {error && (
        <p data-testid="prefs-error" className="mt-6 text-zinc-400">{it ? "Link non valido o scaduto." : "Invalid or expired link."} <Link to="/" className="text-[#E63946]">Home</Link></p>
      )}
      {prefs && (
        <div data-testid="email-preferences" className="mt-6">
          <p className="text-sm text-zinc-400">{it ? "Scegli cosa ricevere su" : "Choose what to receive at"} <span data-testid="prefs-email" className="text-white font-mono">{prefs.email}</span></p>
          <div className="mt-6 space-y-3">
            {ITEMS.map((i) => (
              <label key={i.key} className="flex items-center justify-between gap-4 rounded-lg border border-[#272b35] bg-[#14161b] px-4 py-4 cursor-pointer">
                <span>
                  <span className="block text-white font-semibold text-sm">{i[lang][0]}</span>
                  <span className="block text-xs text-zinc-500">{i[lang][1]}</span>
                </span>
                <Switch checked={prefs[i.key]} onCheckedChange={(v) => setPrefs({ ...prefs, [i.key]: v })} data-testid={`prefs-switch-${i.key}`} />
              </label>
            ))}
          </div>
          <div className="mt-6 flex flex-wrap gap-3">
            <button onClick={() => save({ newsletter: prefs.newsletter, weekly: prefs.weekly, reminders: prefs.reminders })} data-testid="prefs-save-btn"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#E63946] hover:bg-[#D90429] text-white font-bold uppercase rounded-md">
              <Save size={16} /> {it ? "Salva" : "Save"}
            </button>
            <button onClick={() => save({ newsletter: false, weekly: false, reminders: false })} data-testid="prefs-unsubscribe-all-btn"
              className="inline-flex items-center gap-2 px-6 py-3 border border-[#272b35] text-zinc-300 hover:text-white hover:border-zinc-500 font-bold uppercase rounded-md">
              <MailX size={16} /> {it ? "Disiscriviti da tutto" : "Unsubscribe from all"}
            </button>
          </div>
          <Link to="/" data-testid="prefs-home-link" className="mt-6 inline-block text-sm text-[#E63946] hover:text-white">← {it ? "Torna al sito" : "Back to the site"}</Link>
          <p className="mt-4 text-xs text-zinc-500">{it ? "Le email di acquisto e di accesso al Blueprint ti arriveranno comunque." : "Purchase and Blueprint access emails will still be sent."}</p>
        </div>
      )}
    </div>
  );
}
